const allEnvironments: Record<string, any> = {
  local: {
    mixpanelId: '220f5dfe32421d88c2b74c268a15c331',
    googleAnalyticsId: 'UNKNOWN',
    apiRootEndpoint: 'https://localhost:3000',
    aws: {
      identityPoolId: 'us-west-2:0338904d-9bba-4090-9852-7f56f20ec5b9',
      userPoolId: 'us-west-2_ybUxaGP37',
      userPoolWebClientId: '11rsge388bnvlvqrqo2uptc3hf',
      region: 'us-west-2',
    },
    braze: {
      key: 'c8fa5c99-8956-4d3f-86ba-6f242894cb6b',
      baseUrl: 'sdk.iad-02.braze.com',
      appLinkRequestSubscriptionGroupId: 'f57201f8-c11e-4b99-ae12-b5370aeb29c2',
    },
    accessCodes: {
      dtc: 'flexdtc2023',
    },
  },
  sandbox01: {
    mixpanelId: '220f5dfe32421d88c2b74c268a15c331',
    googleAnalyticsId: 'UNKNOWN',
    apiRootEndpoint: 'https://api-sandbox01.carrotsense.com',
    aws: {
      identityPoolId: 'us-west-2:6607fb8c-3f4f-4fae-b2ef-fb98cb0e5965',
      userPoolId: 'us-west-2_DFY2zR2lN',
      userPoolWebClientId: '3ab6ttpb6ak5vn2jc3o1g4f8dt',
      region: 'us-west-2',
    },
    braze: {
      key: 'c8fa5c99-8956-4d3f-86ba-6f242894cb6b',
      baseUrl: 'sdk.iad-02.braze.com',
      appLinkRequestSubscriptionGroupId: 'f57201f8-c11e-4b99-ae12-b5370aeb29c2',
    },
    accessCodes: {
      dtc: 'flexdtc2023',
    },
  },
  sandbox04: {
    mixpanelId: '220f5dfe32421d88c2b74c268a15c331',
    googleAnalyticsId: 'UNKNOWN',
    apiRootEndpoint: 'https://api-sandbox04.carrotsense.com',
    aws: {
      identityPoolId: 'us-west-2:4c0384e3-3451-453b-9f84-b9beadd49a23',
      userPoolId: 'us-west-2_fLgBhQaSx',
      userPoolWebClientId: '2d7q7kk5g7akdgi51ec1c3f76t',
      region: 'us-west-2',
    },
    braze: {
      key: 'c8fa5c99-8956-4d3f-86ba-6f242894cb6b',
      baseUrl: 'sdk.iad-02.braze.com',
      appLinkRequestSubscriptionGroupId: 'f57201f8-c11e-4b99-ae12-b5370aeb29c2',
    },
    accessCodes: {
      dtc: 'flexdtc2023',
    },
  },
  qa01: {
    mixpanelId: '220f5dfe32421d88c2b74c268a15c331',
    googleAnalyticsId: 'UNKNOWN',
    apiRootEndpoint: 'https://api-qa01.carrotsense.com',
    aws: {
      identityPoolId: 'us-west-2:c61d8e45-2d10-49ad-b1c3-fa239b0c6d03',
      userPoolId: 'us-west-2_iN96e8XRc',
      userPoolWebClientId: '7n232jvggeiefbmmfdptcetrel',
      region: 'us-west-2',
    },
    braze: {
      key: 'c8fa5c99-8956-4d3f-86ba-6f242894cb6b',
      baseUrl: 'sdk.iad-02.braze.com',
      appLinkRequestSubscriptionGroupId: 'f57201f8-c11e-4b99-ae12-b5370aeb29c2',
    },
    accessCodes: {
      dtc: 'flexdtc2023',
    },
  },
  production: {
    mixpanelId: '0c5522c377066bf21d7ba2861011cdae',
    googleAnalyticsId: 'G-NQ6FXM4ZPJ',
    apiRootEndpoint: 'https://api.carrotsense.com',
    aws: {
      identityPoolId: 'us-west-2:46216dea-5dc8-4c05-8045-f518dce01e59',
      userPoolId: 'us-west-2_2HJLUmD3U',
      userPoolWebClientId: '3hmqa3aecpp87l8pdnispnsdhm',
      region: 'us-west-2',
    },
    braze: {
      key: '118aaf50-0917-41d4-973a-cf7b8c9ec626',
      baseUrl: 'sdk.iad-02.braze.com',
      appLinkRequestSubscriptionGroupId: '8a0826ad-fe98-4754-aabc-6ebfcda171ed',
    },
    accessCodes: {
      dtc: 'flexdtc2023',
    },
  },
};

const environmentConfig = Object.assign(
  {
    // Place environment variables that have common values here
  },
  allEnvironments[process.env.REACT_APP_ENV || 'local']
);

// Common config
export const {
  mixpanelId,
  googleAnalyticsId,
  apiRootEndpoint,
  branchKey,
  aws,
  braze,
  stripe,
  accessCodes,
} = environmentConfig;
